import FillMethod from './FillMethod'
import { ecpmOrDefault, renderVideo } from '../utils'
import Logger from '../Log'

const Log = Logger.for('VastFillMethod')

export default class VastFillMethod extends FillMethod {
  constructor (bidder) {
    super(bidder.bidder, bidder, 'video', ecpmOrDefault(bidder.params.ecpm, 0.5))
  }

  fill (slot, media) {
    return new Promise((resolve, reject) => {
      const b = this._bidder
      Log.debug('Rendering vast video for ' + b.bidder + ' tag ' + b.params.vast)
      renderVideo({ bidder: b.bidder, vastXml: b.params.vast, type: b.params.type }, slot, media).then((success) => {
        Log.debug('Video render complete')
        resolve({ cpm: success === true ? this.estValue() : 0, format: 'video' })
      })
    })
  }
}
